import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useViewportWidth from 'myHooks/useViewportWidth';

const useStyles = makeStyles(theme => ({
  container: props => ({
    position: 'absolute',
    top: 0,
    left:
      props.type === 'survey-range-slider'
        ? '50%'
        : props.type === 'survey-positive-range-slider'
        ? `calc(50% + ${
            props.screenWidth > 1100 ? '98px' : props.screenWidth <= 1100 && props.screenWidth > 850 ? '113px' : '107px'
          })`
        : `calc(50% + ${
            props.screenWidth > 1100 ? '98px' : props.screenWidth <= 1100 && props.screenWidth > 850 ? '107px' : '100px'
          })`,
    transform: 'translateX(-50%)',
    ...(props.type === 'survey-range-slider'
      ? {
          '@media (max-width: 553px)': {
            left: '245px',
          },
        }
      : props.type === 'survey-positive-range-slider'
      ? {
          '@media (max-width: 529px)': {
            left: '339px',
          },
        }
      : props.type === 'survey-range-slider-left' && !props.isLeftRightLabel
      ? {
          '@media (max-width: 529px)': {
            left: '324px',
          },
        }
      : {
          '@media (max-width: 550px)': {
            left: '264px',
          },
        }),
  }),
  heading: {
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '300',
    color: theme.palette.text.secondary,
    '@media (max-width: 850px)': {
      fontSize: '12px',
    },
  },
  rangeContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  arrow: {
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: '15px solid #CE5378',
  },
  line: props => ({
    width: props.width,
    height: '5px',
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
    margin: '0 8px',
    borderRadius: '2px',

    '@media (max-width: 1100px)': {
      width: `calc(${props.width} * 0.53)`,
    },
    '@media (max-width: 850px)': {
      width: `calc(${props.width} * 0.3)`,
    },
  }),
  labels: props => ({
    color: theme.palette.text.secondary,
    fontWeight: 300,
    whiteSpace: props.shouldLabelsWrap ? 'wrap' : 'nowrap',
    textAlign: props.type === 'survey-range-slider-left' ? 'center' : 'left',
    '@media (max-width: 850px)': {
      fontSize: '12px',
    },
  }),
  firstLabel: props => ({
    width: '71.16px',
    minWidth: '71.16px',
    marginRight: props.type === 'survey-range-slider-left' ? '61px' : '75px',
    '@media (max-width: 1100px)': {
      marginRight: '20px',
    },
    '@media (max-width: 850px)': {
      marginRight: '20px',
      width: '62.7px',
      minWidth: '62.7px',
    },
  }),
  secondLabel: {
    marginLeft: '45px',
    width: '83.22px',
    minWidth: '83.22px',
    '@media (max-width: 1100px)': {
      marginLeft: '20px',
    },
    '@media (max-width: 850px)': {
      marginLeft: '10px',
      width: '71.33px',
      minWidth: '71.33px',
    },
  },
}));

const IdealRange = ({ width, type, labels, isLeftRightLabel }) => {
  const screenWidth = useViewportWidth();
  const shouldLabelsWrap = labels && (labels[0] === 'Strongly disagree' || labels[0] === 'Strongly Oppose');
  const classes = useStyles({ width, type, screenWidth, shouldLabelsWrap, isLeftRightLabel });

  return (
    <Box className={classes.container}>
      <Typography className={classes.heading}>Ideal Range</Typography>
      <Box className={classes.rangeContainer}>
        {labels && <div className={`${classes.labels} ${classes.firstLabel}`}>{labels[0]}</div>}
        <div className={classes.arrow}></div>
        <div className={classes.line}></div>
        <div className={classes.arrow}></div>
        {labels && <div className={`${classes.labels} ${classes.secondLabel}`}>{labels[1]}</div>}
      </Box>
    </Box>
  );
};

export default IdealRange;
